import React from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { connect } from 'react-redux';
import { loadable } from '../../components/loadable';
import { selectSubscribeModals } from '../../../ReduxStorage/SubscriptionPlans/SubscribeModals/selectors';
import { selectIsAdminOfCurrentCourse } from '../../../ReduxStorage/Courses/selectors';
import {
  closeEducatorModal,
  closePersonalPlanModal,
} from '../../../ReduxStorage/SubscriptionPlans/SubscribeModals/dispatchers';
import { selectCurrentUserSubscriptionIds } from '../../../ReduxStorage/UserSubscriptionPlans/selectors';
import { ROUTE_ACCOUNTS_SUBSCRIPTIONS } from '../../../ReduxStorage/routeActions';
import { TabOptionTypes } from '../../containers/SubscriptionsAdmin/types';

const SubscribeAsEducatorModal = loadable(
  () => import('./SubscribeAsEducatorModal'),
  {
    key: 'SubscribeAsEducatorModal',
  }
);

const PersonalPlanModal = loadable(() => import('./PersonalPlanModal'), {
  key: 'PersonalPlanModal',
});

const CourseAccessDeniedModal = loadable(
  () => import('./CourseAccessDeniedModal'),
  {
    key: 'CourseAccessDeniedModal',
  }
);

const LoadableSubscribeModals_ = (props) => {
  const {
    modals,
    isAdminOfCurrentCourse,
    onCloseEducatorModal,
    onClosePersonalModal,
    currentUserSubscriptionIds,
    onRenewSubscription,
  } = props;

  if (modals.educator.show) {
    return (
      <SubscribeAsEducatorModal
        show
        showClose={modals.educator.canDismiss}
        onClose={onCloseEducatorModal}
      />
    );
  }

  if (modals.personal.show) {
    return (
      <PersonalPlanModal
        show
        showClose={modals.personal.canDismiss}
        mode={modals.personal.mode}
        onClose={onClosePersonalModal}
      />
    );
  }

  if (modals.courseAccessDenied.show) {
    return (
      <CourseAccessDeniedModal
        isAdminOfCurrentCourse={isAdminOfCurrentCourse}
        subscriptionId={modals.courseAccessDenied.subscriptionId}
        currentUserSubscriptionIds={currentUserSubscriptionIds}
        onRenewSubscription={onRenewSubscription}
      />
    );
  }

  return null;
};
LoadableSubscribeModals_.propTypes = {
  modals: PropTypes.shape({
    educator: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      canDismiss: PropTypes.bool.isRequired,
    }).isRequired,
    personal: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      canDismiss: PropTypes.bool.isRequired,
      mode: PropTypes.oneOf(['trial', 'subscribe']),
    }).isRequired,
    courseAccessDenied: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      subscriptionId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  isAdminOfCurrentCourse: PropTypes.bool.isRequired,
  currentUserSubscriptionIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onCloseEducatorModal: PropTypes.func.isRequired,
  onClosePersonalModal: PropTypes.func.isRequired,
  onRenewSubscription: PropTypes.func.isRequired,
};

const mapState = (state) => {
  return {
    modals: selectSubscribeModals(state),
    isAdminOfCurrentCourse: selectIsAdminOfCurrentCourse(state),
    currentUserSubscriptionIds: selectCurrentUserSubscriptionIds(state),
  };
};

const mapDispatch = (dispatch) => {
  return {
    onCloseEducatorModal: () => dispatch(closeEducatorModal()),
    onClosePersonalModal: () => dispatch(closePersonalPlanModal()),
    onRenewSubscription: (subscriptionId) => {
      dispatch({
        type: ROUTE_ACCOUNTS_SUBSCRIPTIONS,
        query: {
          subscriptionId,
          view: TabOptionTypes.BILLING_DETAILS,
        },
      });
    },
  };
};

export const LoadableSubscribeModals = hot(
  connect(mapState, mapDispatch)(LoadableSubscribeModals_)
);
